// @ts-check

/** Shared CSV building for every admin export (tag printing, walk-in leads, ...). */

const BOM = '﻿';
// A leading =, +, -, or @ is how Excel/Sheets/LibreOffice recognise a formula; any cell that
// contains admin-typed free text (a customer's name, notes) could start with one by accident or
// on purpose ("CSV injection"). Prefixing with a plain quote defuses it while keeping the text
// readable, same as Excel's own "keep as text" convention.
const FORMULA_PREFIX = /^[=+\-@]/;

/** @param {string | number | null | undefined} value */
export function csvCell(value) {
  const text = value == null ? '' : String(value);
  const guarded = FORMULA_PREFIX.test(text) ? `'${text}` : text;
  return /[",\r\n]/.test(guarded) ? `"${guarded.replace(/"/g, '""')}"` : guarded;
}

/** @param {Array<Array<string | number | null | undefined>>} rows */
export function buildCsv(rows) {
  return BOM + rows.map((row) => row.map(csvCell).join(',')).join('\r\n');
}

/**
 * Save rows as a CSV file in the browser (used by every "Export selected" bulk action).
 * @param {string} filename
 * @param {Array<Array<string | number | null | undefined>>} rows
 */
export function downloadCsv(filename, rows) {
  const url = URL.createObjectURL(new Blob([buildCsv(rows)], { type: 'text/csv;charset=utf-8' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
